import { quiz } from '@constants/data'
import { createContext, Dispatch, ReactNode, SetStateAction, useState } from 'react'

const initStepsHistory = quiz.data?.client_data?.history?.map(Number) || [1]
const initCurrentStep = Number(quiz.data?.client_data?.current_screen || 1)

export const StepsContext = createContext<{
  stepsHistory: Array<number>
  setStepsHistory: Dispatch<SetStateAction<number[]>>
  currentStep: number
  setCurrentStep: Dispatch<SetStateAction<number>>
}>({
  stepsHistory: initStepsHistory,
  setStepsHistory: () => { },
  currentStep: initCurrentStep,
  setCurrentStep: () => { }
})

export function StepsProvider({ children }: { children: ReactNode }) {
  const [stepsHistory, setStepsHistory] = useState<Array<number>>(initStepsHistory)
  const [currentStep, setCurrentStep] = useState<number>(initCurrentStep)

  return (
    <StepsContext
      value={{
        stepsHistory,
        setStepsHistory,
        currentStep,
        setCurrentStep
      }}
    >
      {children}
    </StepsContext>
  )
}
